import React from 'react'
import { Textfield } from '@workboard/wobo-ui'
import { Search } from '@mui/icons-material'

const TextFilter = ({
  textFilter,
  setTextFilter,
  placeholder,
}) => (
  <div className="m-text-filter-container">
    <Search
      className="m-text-filter-icon"
      sx={{ color: '#687587', width: 20, height: 20 }}
    />
    <Textfield
      autoComplete="off"
      onChange={(e) => {
        setTextFilter(e.target.value)
      }}
      placeholder={placeholder}
      type="text"
      value={textFilter}
      className="m-text-filter-input"
    />
  </div>
)

export default TextFilter
